var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import YAML, { DEFAULT_FULL_SCHEMA } from "js-yaml";
import SD from "./serviceDescriptor";
var UploadFile = function (props) {
    var _a = useState(null), error = _a[0], setError = _a[1];
    var onDrop = useCallback(function (acceptedFiles) {
        acceptedFiles.forEach(function (file) {
            var reader = new FileReader();
            // tslint:disable-next-line:no-console
            reader.onabort = function () { return console.log("file reading was aborted"); };
            // tslint:disable-next-line:no-console
            reader.onerror = function () { return console.log("file reading has failed"); };
            reader.onload = function () {
                var data = reader.result;
                if (!data) {
                    return;
                }
                // Parse SD as YAML
                var parsed;
                try {
                    var options = { schema: DEFAULT_FULL_SCHEMA };
                    parsed = typeof data === "string" ? YAML.safeLoad(data, options) : YAML.safeLoad(ab2str(data), options);
                    if (!parsed || !parsed.name) {
                        setError("Doesn't look like a valid service descriptor");
                    }
                    else {
                        var f = file.name.substr(0, file.name.lastIndexOf('.sd.yml')) || file.name.substr(0, file.name.lastIndexOf('.sd.yaml')) || file.name;
                        props.onUpload(new SD(parsed, f));
                        setError(null);
                    }
                }
                catch (e) {
                    setError(e.toString());
                }
            };
            reader.readAsArrayBuffer(file);
        });
        // eslint-disable-next-line
    }, []);
    var _b = useDropzone({ onDrop: onDrop, multiple: false }), getRootProps = _b.getRootProps, getInputProps = _b.getInputProps;
    return (React.createElement("div", null,
        error && React.createElement("span", { style: { color: "red" } }, error),
        React.createElement("div", __assign({}, getRootProps({ className: "dropzone" })),
            React.createElement("input", __assign({}, getInputProps())),
            React.createElement("p", { className: "file-upload-text" }, "Drag 'n' drop files here, or click to select files"))));
};
function ab2str(buf) {
    var decoder = new TextDecoder("utf-8");
    return decoder.decode(new Uint8Array(buf));
}
export default UploadFile;
